import { PaginationStrategy } from './pagination-strategy.service';

export class StaticPaginationStrategy extends PaginationStrategy {
    private _pageCount = 0;
    private _itemsPerPage = 0;

    constructor(itemsPerPage: number) {
        super();
        this._itemsPerPage = itemsPerPage;
    }

    recalculate(numberOfItems: number) {
        this._pageCount = Math.ceil(numberOfItems / this._itemsPerPage);
    }

    getPageCount(): number {
        return this._pageCount;
    }

    getItemsPerPage(): number {
        return this._itemsPerPage;
    }
}
